<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Exams</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <add-school-exam @created="handleCreated"/>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <school-exam-table :data="data" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SchoolExamTable from '@/components/bosemexam/schoolexams/Table/index'
import AddSchoolExam from '@/components/bosemexam/schoolexams/Forms/Add/index'

export default {
  components: {
    SchoolExamTable,
    AddSchoolExam,
  },
  mounted: function() {
    this.getBoards()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
    }
  },
  methods: {
    getBoards: function() {
      this.loading = true
      this.$http.get('/api/exam', {
        params: {
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    handleCreated: function() {
      this.getBoards()
    },
    handleUpdateTable: function() {
      this.getBoards()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getBoards()
    },
    onChange(current) {
      this.current = current
      this.getBoards()
    },
  },
}
</script>
